import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Image, Alert } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import CompanyLayout from '../layouts/CompanyLayout';
import GeneralInfo from './GeneralInfo';
import EnrollmentContacts from './EnrollmentContacts';
import OpenEnrollment from './OpenEnrollment';
import CobraPlans from './CobraPlans';
import config from '../config';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';
import PrintableContent from '../components/ui/PrintableContent';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';
// import { useSidebar } from '../contexts/SidebarContext';

function CobraSummary({ caseId: propCaseId }, ref) {
  
  // const { caseId } = useParams();
  
  const { caseId: paramCaseId } = useParams();
  const caseId = propCaseId || paramCaseId; // Use propCaseId first, fallback to paramCaseId
  const [renewalCase, setRenewalcase] = useState([]);
  const componentRef = useRef(null);

  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));
  // const { toggleSidebar, showSidebar } = useSidebar();

  

  // Create the ref if it's not passed in as a prop
  const effectiveRef = ref || componentRef;

  const handlePrint = useReactToPrint({
    contentRef: effectiveRef,
    onAfterPrint: () => console.log('Print successful'),
  });

  useEffect(() => {
    const fetchcase = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/RenewalCases/${caseId}`);
        setRenewalcase(response.data);
      } catch (error) {
        console.error('Error fetching cases:', error);
      }
    };
    if (caseId) fetchcase();
    fetchcase();
    //fetchPlans();
  }, [caseId]);


  if (!username) return (<Layout>
    <div className="confirmation-container mt-5">
      <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-4">
          <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
        </div>
  
        <Alert variant="danger" className="text-center">Please login from the portal</Alert>
  
  
  
      </Card>
    </div>
  </Layout>);

  return (
    <CompanyLayout caseId={caseId} renewalCase={renewalCase}>
        <div className="row fixedHeader">
        <div className="col-lg-12">
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-start"></div>
            <div className="d-flex justify-content-center">
              <span id="page-title">
                You are currently renewing benefits for <strong>{renewalCase?.employerName || " "}</strong>.
              </span>
            </div>
            <div className="d-flex justify-content-end">
              <span className="pt-1 me-2" id="autoSavedMessage"></span>
            </div>
          </div>
        </div>

        <div className="col-lg-12 mb-1 d-flex justify-content-end">
          <Button
            type="button"
            className="btn btn-success btn-sm mt-1 me-1"
            id="reviewButton"
            onClick={handlePrint}
          >
            Print Summary
          </Button>

        </div>
      </div>
        <PrintableContent ref={effectiveRef}>
          <GeneralInfo caseId={caseId} />
          <CobraPlans caseId={caseId} planType="cobraMedicalPlans" title="Medical Plan Information" coverageType="medicalCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraDentalPlans" title="Dental Plan Information" coverageType="dentalCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraVisionPlans" title="Vision Plan Information" coverageType="visionCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraEAPPlans" title="EAP Plan Information" coverageType="eapCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraHRAPlans" title="HRA Plan Information" coverageType="hraCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraFSAPlans" title="FSA Plan Information" coverageType="fsaCoverageRates" />
          <CobraPlans caseId={caseId} planType="cobraInsurancePlans" title="Insurance Plan Information" coverageType="insuranceCoverageRates" />
          <EnrollmentContacts caseId={caseId} />
          <OpenEnrollment caseId={caseId} />
        </PrintableContent>
    </CompanyLayout>
  );
}

export default React.forwardRef(CobraSummary);
